/* ===========================================================================
   Grupo Marhel — product.js
   Variant selection (pills / select), image gallery swap, quantity stepper,
   add-to-cart, buy now, sticky mobile bar. Vanilla JS.
   =========================================================================== */
(function () {
  'use strict';

  function init() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    var dataEl = section.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var fmt = function (c) { return window.Marhel ? window.Marhel.formatMoney(c) : '$' + (c / 100).toFixed(2); };

    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var addBtn = section.querySelector('[data-add-btn]');
    var addLabel = section.querySelector('[data-add-label]');
    var lineTotal = section.querySelector('[data-line-total]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyBtn = section.querySelector('[data-sticky-add-btn]');
    var galleryMain = section.querySelector('[data-gallery-main]');
    var perUnitEl = section.querySelector('[data-per-unit]');

    var wrappers = Array.prototype.slice.call(section.querySelectorAll('[data-option-wrapper]'));

    function currentSelections() {
      var values = [];
      wrappers.forEach(function (w) {
        var pos = parseInt(w.getAttribute('data-option-position'), 10);
        var pill = w.querySelector('.variant-pill.is-active');
        var select = w.querySelector('[data-option-select]');
        if (pill) values[pos - 1] = pill.getAttribute('data-value');
        else if (select) values[pos - 1] = select.value;
      });
      return values;
    }

    function findVariant(values) {
      if (!values.length) return product.variants[0];
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    /* Pack size from the variant title ("12", "12 Piezas", "Caja 24"...).
       Returns 0 when the variant is not a multi-pack. */
    function packSize(variant) {
      var t = ((variant && variant.title) || '').toLowerCase();
      if (!t || t === 'default title') return 0;
      var lead = t.match(/\d+/);
      if (lead) return parseInt(lead[0], 10);
      if (t.indexOf('48') > -1) return 48;
      if (t.indexOf('24') > -1) return 24;
      if (t.indexOf('12') > -1) return 12;
      return 0;
    }

    function updatePerUnit(variant) {
      if (!perUnitEl) return;
      var n = packSize(variant);
      if (!variant || n < 2) { perUnitEl.setAttribute('hidden', ''); perUnitEl.textContent = ''; return; }
      perUnitEl.removeAttribute('hidden');
      perUnitEl.textContent = fmt(Math.round(variant.price / n)) + ' / pz';
    }

    /* Swap the main gallery image.
       The Liquid image_tag emits a srcset, and a stale srcset always wins over
       a freshly-assigned src -- so it must be replaced (or removed) too, or the
       rendered image never changes. */
    function setMainImage(src, srcset, alt) {
      var img = galleryMain && galleryMain.querySelector('img');
      if (!img || !src) return;
      if (srcset) {
        img.setAttribute('srcset', srcset);
      } else {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }
      img.src = src;
      if (alt) img.alt = alt;
    }

    function updateMedia(variant) {
      if (!galleryMain || !variant || !variant.featured_image) return;
      if (!variant.featured_image.src) return;
      setMainImage(variant.featured_image.src, '', variant.featured_image.alt || product.title);
      /* sync thumb active state */
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') == variant.featured_image.id);
      });
    }

    function render() {
      var variant = findVariant(currentSelections());

      if (!variant) {
        if (addBtn) { addBtn.setAttribute('disabled', ''); }
        if (addLabel) addLabel.textContent = 'No disponible';
        return;
      }

      if (idInput) idInput.value = variant.id;

      /* price */
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + fmt(variant.compare_at_price) + '</s> ';
        }
        html += fmt(variant.price);
        priceEl.innerHTML = html;
      }
      if (stickyPrice) stickyPrice.textContent = fmt(variant.price);

      /* availability */
      if (variant.available) {
        if (addBtn) addBtn.removeAttribute('disabled');
        if (stickyBtn) stickyBtn.removeAttribute('disabled');
        if (addLabel) addLabel.textContent = (window.theme.strings.add_to_cart || 'Agregar al Carrito');
        if (lineTotal) lineTotal.textContent = fmt(variant.price * qty());
      } else {
        if (addBtn) addBtn.setAttribute('disabled', '');
        if (stickyBtn) stickyBtn.setAttribute('disabled', '');
        if (addLabel) addLabel.textContent = (window.theme.strings.sold_out || 'Agotado');
        if (lineTotal) lineTotal.textContent = '';
      }

      updatePerUnit(variant);
      updateMedia(variant);
    }

    /* pills */
    section.querySelectorAll('[data-option-value]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var wrap = pill.closest('[data-option-wrapper]');
        wrap.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        render();
      });
    });

    /* selects */
    section.querySelectorAll('[data-option-select]').forEach(function (sel) {
      sel.addEventListener('change', render);
    });

    /* quantity */
    if (qtyInput) {
      var up = section.querySelector('[data-qty-up]');
      var down = section.querySelector('[data-qty-down]');
      if (up) up.addEventListener('click', function () { qtyInput.value = qty() + 1; render(); });
      if (down) down.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); render(); });
      qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
    }

    /* thumbs */
    section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var thumbImg = thumb.querySelector('img');
        var full = thumb.getAttribute('data-full') || (thumbImg && thumbImg.src);
        if (!full) return;
        setMainImage(
          full,
          thumb.getAttribute('data-srcset') || '',
          thumb.getAttribute('data-alt') || (galleryMain && galleryMain.querySelector('img') || {}).alt
        );
        section.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.hasAttribute('disabled')) return;
        if (window.Cart && window.Cart.add) window.Cart.add(idInput.value, qty());
        else form.submit();
      });
    }

    /* buy now */
    var buyNow = section.querySelector('[data-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (buyNow.hasAttribute('disabled')) return;
        if (window.Cart && window.Cart.add) {
          window.Cart.add(idInput.value, qty(), function () { window.location.href = '/checkout'; });
        }
      });
    }

    /* sticky add button mirrors the form */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.hasAttribute('disabled')) return;
        if (window.Cart && window.Cart.add) window.Cart.add(idInput.value, qty());
      });
    }

    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
